import { computeFaqClick } from '../helpers/faq-helper';
import { chatScrollHandler, scrollOnQuestionExpand } from "../helpers/chat-scroll";
import { relatedContent } from '../helpers/search-helpers';
import { messageRating } from '../helpers/rating-helper';
import { questionFormSubmit } from '../helpers/question-helper';

document.addEventListener('turbolinks:load', function() {
  const body = $('body');
  if (body.data('controller') !== 'questions' || body.data('action') !== 'new') return;
  pageBootstrap();
});

let pageBootstrap = () => {
  chatScrollHandler();
  scrollOnQuestionExpand();
  messageRating(pageBootstrap);
  relatedContent('.question-ajax-form', '.question-container','related_content', '.related-content .category-container');
  computeFaqClick();
  questionFormSubmit(pageBootstrap);
};
